<div class="bd-mahnwesen-kpi">

    <!-- Loading -->
    @if (loading) {
        <div class="flex align-items-center gap-2 p-3 text-color-secondary">
            <i class="fa-solid fa-spinner fa-spin"></i>
            <span>KPIs werden geladen …</span>
        </div>
    }

    <!-- Error -->
    @if (!loading && hasError) {
        <div class="p-message p-message-error p-3">
            <i class="fa-solid fa-triangle-exclamation mr-2"></i>
            <span>KPI-Daten konnten nicht geladen werden.</span>
        </div>
    }

    <!-- KPI cards -->
    @if (!loading && !hasError && kpi) {
        <div class="grid gap-3">

            <!-- Aktive Mahnungen -->
            <div class="col-12 md:col-4 lg:col-2">
                <div class="surface-card border-round p-3 shadow-1 text-center">
                    <div class="text-3xl font-bold text-primary">{{ kpi.activeDunnings }}</div>
                    <div class="text-sm text-color-secondary mt-1">Aktive Mahnungen</div>
                </div>
            </div>

            <!-- Offene Aktionen -->
            <div class="col-12 md:col-4 lg:col-2">
                <div class="surface-card border-round p-3 shadow-1 text-center"
                     [ngClass]="{'bg-orange-50': kpi.openActions > 0}">
                    <div class="text-3xl font-bold"
                         [ngClass]="kpi.openActions > 0 ? 'text-orange-600' : 'text-primary'">
                        {{ kpi.openActions }}
                    </div>
                    <div class="text-sm text-color-secondary mt-1">Offene Aktionen</div>
                </div>
            </div>

            <!-- Ausstehende Freigaben -->
            <div class="col-12 md:col-4 lg:col-2">
                <div class="surface-card border-round p-3 shadow-1 text-center"
                     [ngClass]="{'bg-yellow-50': kpi.pendingApprovals > 0}">
                    <div class="text-3xl font-bold"
                         [ngClass]="kpi.pendingApprovals > 0 ? 'text-yellow-600' : 'text-primary'">
                        {{ kpi.pendingApprovals }}
                    </div>
                    <div class="text-sm text-color-secondary mt-1">Ausstehende Freigaben</div>
                </div>
            </div>

            <!-- Gebrochene Pläne -->
            <div class="col-12 md:col-4 lg:col-2">
                <div class="surface-card border-round p-3 shadow-1 text-center"
                     [ngClass]="{'bg-red-50': kpi.breachedPlans > 0}">
                    <div class="text-3xl font-bold"
                         [ngClass]="kpi.breachedPlans > 0 ? 'text-red-600' : 'text-primary'">
                        {{ kpi.breachedPlans }}
                    </div>
                    <div class="text-sm text-color-secondary mt-1">Gebrochene Zahlungspläne</div>
                </div>
            </div>

            <!-- Aktive Pausen -->
            <div class="col-12 md:col-4 lg:col-2">
                <div class="surface-card border-round p-3 shadow-1 text-center">
                    <div class="text-3xl font-bold text-primary">{{ kpi.activePauses }}</div>
                    <div class="text-sm text-color-secondary mt-1">Aktive Pausen</div>
                </div>
            </div>

            <!-- Pro Level -->
            @if (getLevelEntries().length > 0) {
                <div class="col-12 md:col-6 lg:col-4">
                    <div class="surface-card border-round p-3 shadow-1">
                        <div class="font-semibold text-color-secondary mb-2">Mahnungen pro Level</div>
                        <div class="flex flex-wrap gap-2">
                            @for (entry of getLevelEntries(); track entry.level) {
                                <div class="flex align-items-center gap-1 surface-100 border-round px-2 py-1 text-sm">
                                    <span class="font-semibold">{{ entry.level }}</span>
                                    <span class="text-color-secondary">{{ entry.count }}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }

            <!-- Pro Pfad -->
            @if (getPfadEntries().length > 0) {
                <div class="col-12 md:col-6 lg:col-4">
                    <div class="surface-card border-round p-3 shadow-1">
                        <div class="font-semibold text-color-secondary mb-2">Mahnungen pro Typ</div>
                        <div class="flex flex-col gap-1">
                            @for (entry of getPfadEntries(); track entry.pfad) {
                                <div class="flex justify-content-between align-items-center border-bottom-1 surface-border py-1 text-sm">
                                    <span class="text-color-secondary overflow-hidden text-overflow-ellipsis white-space-nowrap"
                                          style="max-width: 160px" [title]="entry.pfad">{{ entry.pfad }}</span>
                                    <span class="font-semibold ml-2">{{ entry.count }}</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }

        </div>
    }

    <!-- Empty state -->
    @if (!loading && !hasError && !kpi) {
        <div class="p-3 text-color-secondary">
            Keine KPI-Daten verfügbar.
        </div>
    }

</div>
